module.exports = __webpack_public_path__ + "static/author-1-1-b1fdde4aa3e05077814afa8eda96873a.jpg";